import styled from 'styled-components';
import tw, { css } from 'twin.macro';

export default styled.svg.attrs((props) => ({
  color: props.$color,
  'data-test-color': props.$color
}))(({ $size, $color }) => [
  tw`inline-block select-none flex-shrink-0 pointer-events-none `,
  css`
    width: 1em;
    height: 1em;
    font-size: 1.5rem;
  `,

  /* Fill */
  $color === 'current' && tw`fill-current`,

  /* Size */
  $size === 'small' && tw`text-lg`,
  $size === 'medium' &&
    css`
      font-size: 1.25rem;
    `,
  $size === 'inherit' &&
    css`
      font-size: 1em;
    `
]);
